import { createSlice } from "@reduxjs/toolkit";

const configMailSlice = createSlice({
  name: "configMail",
  initialState: {
    isLoading: false,
    isLoadingData: false,
    configMailList: [],
    commonTypeByGroupType: []
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setIsLoadingData(state, action) {
      state.isLoadingData = action.payload;
    },
    setConfigMailList(state, action) {
      state.configMailList = action.payload;
    },
    setCommonTypeByGroupType(state, action) {
      state.commonTypeByGroupType = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setIsLoadingData,
  setConfigMailList,
  setCommonTypeByGroupType
} = configMailSlice.actions;
export default configMailSlice.reducer;
